<template>
    <error heading="401 Not Good Enough" showNavHome>
        <template v-slot:image>
            <img
                src="@/assets/images/pages/401.png"
                alt="error-graphic"
                class="mx-auto mb-4 max-w-full"
            />
        </template>
        Sometimes, the world just tries it's hardest to say: "you're not good enough", sometimes
        there's just nothing that can be done and there's no cake left to make it better.<br /><br />Luckily,
        this companion cube loves you just the way you are. It knows just how you are feeling and
        will selflessly give of itself when you need it most.
    </error>
</template>

<script>
import Error from './Error'

export default {
    components: {
        Error
    }
}
</script>
